import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/models/page';

export const Route = createFileRoute('/_app/settings/models/')({
  component: Page,
});
